// extracted by mini-css-extract-plugin
module.exports = {"root":"TimeOffCalendar_root__2aCag","calendarContainer":"TimeOffCalendar_calendarContainer__90Eoh","event":"TimeOffCalendar_event__3KPDv"};